"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68106],{

/***/ 82906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BubbleChat_ShareTradeAttachment; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/Icons/CornerUpRightSvg.tsx

var CornerUpRightSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 7L10 4.5L7.5 2",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 10V6.5C2 5.96957 2.21071 5.46086 2.58579 5.08579C2.96086 4.71071 3.46957 4.5 4 4.5H10",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_CornerUpRightSvg = (CornerUpRightSvg);

// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
;// CONCATENATED MODULE: ./src/global/Icons/VerifiedSvg.tsx

var VerifiedSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.01819 9.48603C2.08412 9.26126 2.19301 8.82172 2.34286 8.39716C2.44051 8.14764 2.44051 7.87048 2.34286 7.62097C2.20159 7.2781 2.09743 6.92109 2.03218 6.55606C1.95451 6.15825 2.01847 5.74582 2.21296 5.39022C2.40745 5.03462 2.72023 4.75828 3.09708 4.60908C3.43255 4.47361 3.73747 4.27226 3.99381 4.01695C4.25015 3.76163 4.45272 3.45753 4.58954 3.12261C4.67451 2.90141 4.8035 2.69976 4.96872 2.5299C5.13393 2.36003 5.33192 2.22549 5.55068 2.13441C5.76944 2.04334 6.00441 1.99765 6.24136 2.00009C6.4783 2.00253 6.71228 2.05305 6.92912 2.14861C7.61406 2.42938 8.38197 2.42938 9.06691 2.14861C9.27736 2.05639 9.50408 2.00707 9.73382 2.00352C9.96355 1.99997 10.1917 2.04227 10.4049 2.12794C10.6181 2.2136 10.8121 2.34093 10.9755 2.50246C11.1389 2.66398 11.2684 2.85647 11.3565 3.06866C11.6565 3.77484 12.2177 4.33783 12.9229 4.64004C13.1345 4.72468 13.327 4.8507 13.4892 5.0107C13.6514 5.1707 13.7801 5.36147 13.8676 5.57183C13.9552 5.78218 13.9998 6.00789 13.999 6.23574C13.9982 6.46358 13.952 6.68897 13.863 6.8987C13.5762 7.61951 13.5802 8.42342 13.8739 9.14138C14.0254 9.53303 14.0297 9.96631 13.8861 10.3609C13.7424 10.7555 13.4606 11.0846 13.0928 11.2872C13.0345 11.3332 12.9708 11.3718 12.903 11.402C12.5501 11.5253 12.2294 11.7261 11.9646 11.9898C11.6997 12.2535 11.4974 12.5732 11.3725 12.9255C11.1896 13.3492 10.8491 13.6854 10.423 13.8628C9.99693 14.0403 9.51854 14.0452 9.08889 13.8765C8.75014 13.7194 8.3815 13.6372 8.0081 13.6355C7.6347 13.6337 7.26531 13.7125 6.92513 13.8665C6.48897 14.0453 5.99985 14.0445 5.56428 13.8643C5.12871 13.6841 4.78195 13.3391 4.59953 12.9045C4.46772 12.5663 4.26787 12.2588 4.01234 12.0011C3.75682 11.7433 3.45107 11.5408 3.11406 11.406C2.74589 11.2508 2.43907 10.9786 2.241 10.6316C2.04294 10.2846 1.96463 9.88199 2.01819 9.48603ZM7.41262 8.95159C7.32571 8.87067 7.25678 8.81073 7.19185 8.7468C6.93312 8.49306 6.68637 8.22634 6.41565 7.98658C6.30159 7.87942 6.14964 7.82194 5.9932 7.82681C5.83677 7.83168 5.68868 7.8985 5.58151 8.01256C5.47434 8.12662 5.41687 8.27857 5.42174 8.435C5.42661 8.59144 5.49343 8.73952 5.60749 8.84669C6.04803 9.29922 6.49357 9.74577 6.9491 10.1853C7.00239 10.2543 7.07095 10.3099 7.14939 10.3479C7.22782 10.3858 7.31399 10.4051 7.40112 10.4041C7.48825 10.4031 7.57398 10.382 7.65155 10.3423C7.72912 10.3026 7.79642 10.2454 7.84817 10.1753C8.8851 9.14971 9.91737 8.11945 10.945 7.08452C11.0118 7.03244 11.0664 6.96626 11.1047 6.89069C11.1431 6.81512 11.1643 6.73202 11.1669 6.64732C11.1695 6.56261 11.1533 6.47837 11.1196 6.40061C11.0859 6.32285 11.0355 6.25348 10.9719 6.19743C10.848 6.09001 10.6868 6.03556 10.5232 6.04584C10.3595 6.05612 10.2064 6.13029 10.0968 6.25237C9.93002 6.4142 9.76619 6.57904 9.60236 6.74387L7.41262 8.95159Z",
                fill: "#00AB6B"
            })
        ]
    });
};
/* harmony default export */ var Icons_VerifiedSvg = (VerifiedSvg);

;// CONCATENATED MODULE: ./src/typings/api/shareTradeChat.ts
var UpdatedShareOrderStatus;
(function(UpdatedShareOrderStatus) {
    UpdatedShareOrderStatus["Unspecified"] = "UPDATED_STATUS_UNSPECIFIED";
    UpdatedShareOrderStatus["Amended"] = "UPDATED_STATUS_AMENDED";
    UpdatedShareOrderStatus["Cancelled"] = "UPDATED_STATUS_CANCELLED";
})(UpdatedShareOrderStatus || (UpdatedShareOrderStatus = {}));
var ShareTradeLabel;
(function(ShareTradeLabel) {
    ShareTradeLabel["UNSPECIFIED"] = "LABEL_UNSPECIFIED";
    ShareTradeLabel["DAY_TRADE"] = "LABEL_DAY_TRADE";
    ShareTradeLabel["SPLIT_ORDER"] = "LABEL_SPLIT_ORDER";
})(ShareTradeLabel || (ShareTradeLabel = {}));

// EXTERNAL MODULE: ./src/typings/api/shareTradeShare.ts
var shareTradeShare = __webpack_require__(10529);
// EXTERNAL MODULE: ./src/features/sharetrade/analytics/shareTradeGroupChat.ts
var shareTradeGroupChat = __webpack_require__(30196);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/chat/MainContent/BubbleChat/ShareTradeAttachment.styled.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  flex-wrap: nowrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  height: 100%;\n\n  img {\n    margin-top: -1px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: unset;\n  text-align: left;\n  padding: 6px 12px;\n  width: 100%;\n  border: 0;\n\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n\n  & > .anticon + span {\n    margin-left: 4px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 14px 14px 0 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n  margin-left: ",
        ";\n  text-decoration: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #b5b5b5 !important;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 22px;\n  margin: 0;\n  text-wrap: nowrap;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 267px;\n  cursor: pointer;\n  border-radius: 14px;\n  background: ",
        ";\n\n  & ",
        " ",
        ", ",
        " ",
        " {\n    color: ",
        ";\n  }\n\n  & ",
        " {\n    color: ",
        ";\n  }\n\n  & ",
        " {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: auto;\n\n  display: flex;\n  text-align: left;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  & > .ant-row {\n    width: 100%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n  color: #b5b5b5;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  color: #b5b5b5;\n  margin: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  margin: 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var _obj;
var shareTradeBubbleConfig = (_obj = {}, (0,_define_property/* default */.Z)(_obj, shareTradeShare/* ShareOrderType.Unspecified */.y.Unspecified, {
    background: "transparent",
    header: "transparent",
    text: "#333333"
}), (0,_define_property/* default */.Z)(_obj, shareTradeShare/* ShareOrderType.Buy */.y.Buy, {
    background: "#E5F7F0",
    header: "#CCF1EA",
    text: "#00B897"
}), (0,_define_property/* default */.Z)(_obj, shareTradeShare/* ShareOrderType.Sell */.y.Sell, {
    background: "#FDEDED",
    header: "#FBDFDF",
    text: "#EE4A49"
}), _obj);
var TradeRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-723005ab-0"
})(_templateObject());
var TitleRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-723005ab-1"
})(_templateObject1());
var BadgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-723005ab-2"
})(_templateObject2());
var PreviousOrderButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "link"
}).withConfig({
    componentId: "sc-723005ab-3"
})(_templateObject3());
var PreviousOrderCol = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-723005ab-4"
})(_templateObject4());
var PriceText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-723005ab-5"
})(_templateObject5(), function(param) {
    var _marginLeft = param.marginLeft, marginLeft = _marginLeft === void 0 ? "0" : _marginLeft;
    return marginLeft;
}, function(param) {
    var lineThrough = param.lineThrough;
    return lineThrough ? "line-through" : "none";
});
var TotalInvestmentText = (0,styled_components_browser_esm/* default */.ZP)(PriceText).withConfig({
    componentId: "sc-723005ab-6"
})(_templateObject6());
var Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-723005ab-7"
})(_templateObject7());
var ContainerRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-723005ab-8"
})(_templateObject8(), function(param) {
    var orderType = param.orderType;
    var ref;
    return (ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.background;
}, TradeRow, PriceText, TradeRow, Title, function(param) {
    var orderType = param.orderType;
    var ref;
    return ((ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.text) || "#333333";
}, PreviousOrderButton, function(param) {
    var orderType = param.orderType;
    var ref;
    return ((ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.text) || "#333333";
}, PreviousOrderCol, function(param) {
    var orderType = param.orderType;
    var ref;
    return ((ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.header) || "transparent";
});
var ContentButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-723005ab-9"
})(_templateObject9());
var ContentRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-723005ab-10"
})(_templateObject10());
var StatusText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-723005ab-11"
})(_templateObject11());
var TimeText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-723005ab-12"
})(_templateObject12());
var Username = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-723005ab-13"
})(_templateObject13(), function(param) {
    var _color = param.color, color = _color === void 0 ? "#333333" : _color;
    return color;
});

;// CONCATENATED MODULE: ./src/features/chat/MainContent/BubbleChat/ShareTradeAttachment.tsx














var ShareTradeAttachment = function(param) {
    var roomId = param.roomId, messageId = param.messageId, chatRoomType = param.chatRoomType, _info = param.info, info = _info === void 0 ? {} : _info, _username = param.username, username = _username === void 0 ? "" : _username, usernameColor = param.usernameColor, _previousButtonText = param.previousButtonText, previousButtonText = _previousButtonText === void 0 ? "See Previous Order" : _previousButtonText, _isVerified = param.isVerified, isVerified = _isVerified === void 0 ? false : _isVerified, _hideUsername = param.hideUsername, hideUsername = _hideUsername === void 0 ? false : _hideUsername, _hidePreviousOrder = param.hidePreviousOrder, hidePreviousOrder = _hidePreviousOrder === void 0 ? false : _hidePreviousOrder, _onPreviousOrderClick = param.onPreviousOrderClick, onPreviousOrderClick = _onPreviousOrderClick === void 0 ? function() {} : _onPreviousOrderClick, _isPreview = param.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview;
    var ref;
    var router = (0,next_router.useRouter)();
    var symbol = info.symbol, text = info.text, price = info.price, status = info.status, updatedPrice = info.updated_price, orderType = info.order_type, orderTime = info.order_time, totalInvestment = info.total_investment, label = info.label;
    var isDayTrade = label === ShareTradeLabel.DAY_TRADE;
    var isSplitOrder = label === ShareTradeLabel.SPLIT_ORDER;
    var isLineThrough = (0,react.useMemo)(function() {
        return [
            shareTradeShare/* ShareOrderStatus.Amend */.F.Amend,
            shareTradeShare/* ShareOrderStatus.Cancel */.F.Cancel
        ].includes(status);
    }, [
        status
    ]);
    var getOrderTitleBadge = function() {
        if (!label || label === ShareTradeLabel.UNSPECIFIED) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isSplitOrder,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/share-trade/split-order.svg"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isDayTrade,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/share-trade/day-trade.svg"
                    })
                })
            ]
        });
    };
    var handlePreviousOrderClick = function() {
        if (isPreview) return;
        (0,shareTradeGroupChat/* trackChatPreviousOrder */.Jw)(roomId === null || roomId === void 0 ? void 0 : roomId.toString(), messageId === null || messageId === void 0 ? void 0 : messageId.toString(), symbol, status, chatRoomType);
        onPreviousOrderClick();
    };
    var handleContentClick = function() {
        if (isPreview) return;
        (0,shareTradeGroupChat/* trackChatCompanySymbol */.As)(roomId === null || roomId === void 0 ? void 0 : roomId.toString(), messageId === null || messageId === void 0 ? void 0 : messageId.toString(), symbol, status, chatRoomType);
        router.push("/symbol/".concat(symbol));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerRow, {
        align: "middle",
        justify: "space-between",
        orderType: orderType,
        className: "share-preview",
        children: [
            hidePreviousOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviousOrderCol, {
                className: "st-col-header",
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviousOrderButton, {
                    type: "link",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        component: Icons_CornerUpRightSvg
                    }),
                    onClick: handlePreviousOrderClick,
                    children: previousButtonText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentButton, {
                    onClick: handleContentClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentRow, {
                        align: "middle",
                        gutter: [
                            0,
                            6
                        ],
                        children: [
                            !hideUsername && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    align: "middle",
                                    gutter: [
                                        4,
                                        0
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Username, {
                                                color: usernameColor,
                                                children: username
                                            })
                                        }),
                                        isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: Icons_VerifiedSvg
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    align: "middle",
                                    justify: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                            span: 22,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                            span: 24,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleRow, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                                                        children: text.split(symbol).map(function(item) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                children: item || /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                                    children: symbol
                                                                                })
                                                                            }, item);
                                                                        })
                                                                    }),
                                                                    getOrderTitleBadge()
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                                            lineThrough: isLineThrough,
                                                            children: price
                                                        }),
                                                        updatedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                                            marginLeft: "8px",
                                                            children: updatedPrice
                                                        }),
                                                        !!totalInvestment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalInvestmentText, {
                                                            marginLeft: "4px",
                                                            children: [
                                                                "• ",
                                                                totalInvestment
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeText, {
                                                    children: new Date(orderTime).toLocaleTimeString(undefined, {
                                                        hour12: false
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                component: ChevronDownSvg/* default */.Z,
                                                style: {
                                                    fontSize: 16,
                                                    color: (ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.text,
                                                    transform: "rotate(-90deg)"
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BubbleChat_ShareTradeAttachment = (ShareTradeAttachment);


/***/ }),

/***/ 70963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShareTrade_PopOverInvestment; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 1 modules
var popover = __webpack_require__(10808);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/features/chat/MainContent/BubbleChat/ShareTradeAttachment.tsx + 4 modules
var ShareTradeAttachment = __webpack_require__(82906);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var entities_profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/PopOverInvestment/constant.ts
var POPOVER_TITLE = {
    CHECKED: "Share Investment Amount",
    UNCHECKED: "Share without Investment Amount"
};
var TOOLTIP_TITLE = "Investment amount will be displayed along with price if you turn the toggle on.";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/PopOverInvestment/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  background: #f7f7f7;\n  padding: 2px 6px;\n  border-radius: 4px;\n  width: fit-content;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n\n  span {\n    color: ",
        ";\n    font-size: 12px;\n    padding: 0;\n    margin: 0;\n    line-height: normal;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  min-width: 250px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n  padding: 12px;\n  border-bottom: 1px solid #ededed;\n\n  span {\n    font-size: 13px;\n    font-weight: bold;\n  }\n  \n  img {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var PopOverButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1c4cca3-0"
})(_templateObject(), function(param) {
    var isActive = param.isActive;
    return isActive ? "#00ab6b" : "#858585";
}, function(param) {
    var isMaxWidth = param.isMaxWidth;
    return isMaxWidth && "\n    width: 100%;\n  ";
});
var PopOverContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1c4cca3-1"
})(_templateObject1());
var ContentHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1c4cca3-2"
})(_templateObject2());
var HeaderTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1c4cca3-3"
})(_templateObject3());
var ContentCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1c4cca3-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/PopOverInvestment/index.tsx










var PopOverInvestment = function(param) {
    var isSelected = param.isSelected, defaultSwitchValue = param.defaultSwitchValue, previewShareTrade = param.previewShareTrade, _isScrolling = param.isScrolling, isScrolling = _isScrolling === void 0 ? false : _isScrolling, _placement = param.placement, placement = _placement === void 0 ? "bottomLeft" : _placement, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? false : _maxWidth, _onSwitchChange = param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,react.useState)(defaultSwitchValue), isSwitchChecked = ref1[0], setIsSwitchChecked = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(entities_profile/* selectors */.wl), profile = ref2.data;
    var handleChangeSwitch = function(checked) {
        setIsSwitchChecked(checked);
        onSwitchChange(checked);
        setVisible(false);
    };
    (0,react.useEffect)(function() {
        setIsSwitchChecked(defaultSwitchValue);
    }, [
        isSelected,
        defaultSwitchValue
    ]);
    (0,react.useEffect)(function() {
        if (isScrolling) setVisible(false);
    }, [
        isScrolling
    ]);
    var popOverText = isSwitchChecked ? POPOVER_TITLE.CHECKED : POPOVER_TITLE.UNCHECKED;
    var iconSuffix = isSwitchChecked ? "_active" : "";
    var PopOverIcon = {
        height: 14,
        width: 14
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
        trigger: [
            "click",
            "contextMenu"
        ],
        placement: placement,
        destroyTooltipOnHide: true,
        visible: visible,
        onVisibleChange: function() {
            return setVisible(!visible);
        },
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopOverContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderTitleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: POPOVER_TITLE.CHECKED
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                        title: TOOLTIP_TITLE,
                                        trigger: [
                                            "click",
                                            "contextMenu"
                                        ],
                                        placement: "bottom",
                                        overlayClassName: "tooltip-overlay-green",
                                        destroyTooltipOnHide: true,
                                        overlayStyle: {
                                            minWidth: 320
                                        },
                                        overlayInnerStyle: {
                                            background: "#00ab6b"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                                            src: "/icon/info.svg",
                                            alt: "close"
                                        }, PopOverIcon))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_switch/* default */.Z, {
                                checked: isSwitchChecked,
                                onChange: handleChangeSwitch,
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTradeAttachment/* default */.Z, {
                            info: previewShareTrade,
                            username: profile.username,
                            isVerified: false,
                            usernameColor: "#94B041",
                            hidePreviousOrder: false,
                            hideUsername: false,
                            onPreviousOrderClick: function() {},
                            isPreview: true
                        })
                    })
                ]
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopOverButton, {
            isActive: isSwitchChecked,
            isMaxWidth: maxWidth,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/sharetrade/currency".concat(iconSuffix, ".svg"),
                    alt: "icon"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: popOverText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/sharetrade/arrow".concat(iconSuffix, ".svg"),
                    alt: "icon",
                    className: "icon-arrow"
                })
            ]
        })
    });
};
/* harmony default export */ var ShareTrade_PopOverInvestment = (PopOverInvestment);


/***/ }),

/***/ 30196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "As": function() { return /* binding */ trackChatCompanySymbol; },
/* harmony export */   "Jw": function() { return /* binding */ trackChatPreviousOrder; },
/* harmony export */   "RA": function() { return /* binding */ trackAllowMemberShareTrade; },
/* harmony export */   "eD": function() { return /* binding */ trackMemberActivateNow; },
/* harmony export */   "mA": function() { return /* binding */ trackConfirmedMemberAutoShare; },
/* harmony export */   "tM": function() { return /* binding */ trackGroupAutoShare; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var roomTypeValue = {
    ROOM_TYPE_PERSONAL: "Personal",
    ROOM_TYPE_GROUP: "Group",
    ROOM_TYPE_BROADCAST: "Broadcast"
};
// Action
var trackGroupAutoShare = function(roomId, isAdmin, isAutoShareOn) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Group Chat Action", {
        Action: "Group Chat Auto-Share Trade Selected",
        "Room ID": roomId,
        "Member Type": isAdmin ? "Admin" : "Non Admin",
        "Auto Share": isAutoShareOn ? "On" : "Off"
    });
};
var trackAllowMemberShareTrade = function(roomId, isAutoShareOn) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Group Chat Action", {
        Action: "Group Chat Allow Member Share Trade Selected",
        "Room ID": roomId,
        "Enable Member Share": isAutoShareOn ? "On" : "Off"
    });
};
var trackMemberActivateNow = function(roomId) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Member Activate Now Selected",
        "Room ID": roomId
    });
};
var trackConfirmedMemberAutoShare = function(roomId) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Confirmed Member Auto-Share",
        "Room ID": roomId
    });
};
var trackChatCompanySymbol = function(roomId, messageId, symbol, orderStatus, roomType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Chat Company Symbol Selected",
        "Room ID": roomId,
        "Message ID": messageId,
        Symbol: symbol,
        "Order Status": orderStatus,
        "Chat Room Type": roomTypeValue[roomType]
    });
};
var trackChatPreviousOrder = function(roomId, messageId, symbol, orderStatus, roomType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Chat See Previous Order Company Symbol Selected",
        "Room ID": roomId,
        "Message ID": messageId,
        Symbol: symbol,
        "Order Status": orderStatus,
        "Chat Room Type": roomTypeValue[roomType]
    });
};


/***/ }),

/***/ 26142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Icons/CloseSvg.tsx
var CloseSvg = __webpack_require__(79928);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/alert/index.js + 2 modules
var es_alert = __webpack_require__(90567);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Alert/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 20px;\n\n  &.ant-alert-info {\n    border: none;\n    background-color: #f2f1fe;\n\n    .ant-alert-message,\n    .anticon-info-circle {\n      color: #8277f8;\n    }\n  }\n\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BaseAlert = (0,styled_components_browser_esm/* default */.ZP)(es_alert/* default */.Z).withConfig({
    componentId: "sc-f50812bc-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/global/Alert/index.tsx





var Alert = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseAlert, (0,_object_spread/* default */.Z)({
        closeText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            component: CloseSvg/* default */.Z,
            style: {
                color: "#969696",
                fontSize: 10
            }
        })
    }, props));
};
/* harmony default export */ var global_Alert = (Alert);


/***/ }),

/***/ 79928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseSvg = function(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _stroke = param.stroke, stroke = _stroke === void 0 ? "currentColor" : _stroke, _width = param.width, width = _width === void 0 ? "1em" : _width, _height = param.height, height = _height === void 0 ? "1em" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11 1.5L1 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1 1.5L11 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseSvg);


/***/ }),

/***/ 51595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65344);
/* harmony import */ var _BaseModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16981);







var BaseConfirmationModal = function(_param) /*#__PURE__*/ {
    var description = _param.description, _cancelText = _param.cancelText, cancelText = _cancelText === void 0 ? "Cancel" : _cancelText, _confirmText = _param.confirmText, confirmText = _confirmText === void 0 ? "Confirm" : _confirmText, _hideSubmitButton = _param.hideSubmitButton, hideSubmitButton = _hideSubmitButton === void 0 ? false : _hideSubmitButton, _hideCancelButton = _param.hideCancelButton, hideCancelButton = _hideCancelButton === void 0 ? false : _hideCancelButton, _onConfirm = _param.onConfirm, onConfirm = _onConfirm === void 0 ? function() {} : _onConfirm, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "description",
        "cancelText",
        "confirmText",
        "hideSubmitButton",
        "hideCancelButton",
        "onConfirm",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BaseModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: [
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .DescriptionRow */ .uw, {
                className: "description",
                align: "middle",
                justify: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .Description */ .dk, {
                        children: description
                    })
                })
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .ButtonRow */ .VR, {
                className: "button-row",
                gutter: 16,
                children: [
                    !hideCancelButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: hideSubmitButton ? 24 : 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .CancelButton */ .Lw, {
                            onClick: props.onCancel,
                            block: true,
                            children: cancelText
                        })
                    }),
                    !hideSubmitButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: hideCancelButton ? 24 : 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .ConfirmButton */ .pu, {
                            type: "primary",
                            onClick: onConfirm,
                            loading: props.confirmLoading,
                            block: true,
                            children: confirmText
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseConfirmationModal);


/***/ }),

/***/ 65344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lw": function() { return /* binding */ CancelButton; },
/* harmony export */   "VR": function() { return /* binding */ ButtonRow; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "pu": function() { return /* binding */ ConfirmButton; },
/* harmony export */   "uw": function() { return /* binding */ DescriptionRow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #858585;\n  text-align: center;\n\n  margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 40px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  color: #333333;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: #333333;\n    border-color: #ededed;\n  }\n\n  &::after {\n    box-shadow: 0 0 0 0 #000000 !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  color: #ffffff;\n  border-radius: 4px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var DescriptionRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-0"
})(_templateObject());
var Description = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-7df14943-1"
})(_templateObject1());
var ButtonRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-2"
})(_templateObject2());
var CancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-3"
})(_templateObject3());
var ConfirmButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-4"
})(_templateObject4());


/***/ }),

/***/ 16981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16165);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71230);
/* harmony import */ var global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79928);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89997);








var BaseModal = function(_param) /*#__PURE__*/ {
    var prefix = _param.prefix, title = _param.title, children = _param.children, _closable = _param.closable, closable = _closable === void 0 ? true : _closable, _hideHeader = _param.hideHeader, hideHeader = _hideHeader === void 0 ? false : _hideHeader, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "prefix",
        "title",
        "children",
        "closable",
        "hideHeader"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        centered: true,
        footer: null
    }, props), {
        closable: false,
        children: [
            !hideHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .HeaderRow */ .VJ, {
                className: "base-modal-header",
                align: "middle",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 1,
                        children: prefix
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 22,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            align: "middle",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
                                    className: "base-modal-title",
                                    children: title
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 1,
                        children: closable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .CloseButton */ .PZ, {
                            onClick: props.onCancel,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                style: {
                                    fontSize: 10,
                                    color: "#969696"
                                },
                                component: global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
                            })
                        })
                    })
                ]
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseModal);


/***/ }),

/***/ 89997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "PZ": function() { return /* binding */ CloseButton; },
/* harmony export */   "VJ": function() { return /* binding */ HeaderRow; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33070);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n  & .ant-modal-body {\n    padding: 24px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 22px;\n  padding: 0 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-90095253-0"
})(_templateObject());
var HeaderRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-90095253-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-90095253-2"
})(_templateObject2());
var CloseButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-90095253-3"
})(_templateObject3());


/***/ }),

/***/ 972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12902);
/* harmony import */ var lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14732);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6430);










var initialState = {
    data: undefined,
    isEmptyList: false,
    isLoading: false,
    isUpdateLoading: false,
    error: undefined,
    updateError: undefined
};
var useShareTradeTarget = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadShareTradeTarget: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
                var disableLoading, initialLoad, restParams, axiosResponse, data, _args = arguments;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            disableLoading = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                            initialLoad = params.initialLoad, restParams = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(params, [
                                "initialLoad"
                            ]);
                            _ctx.prev = 2;
                            set({
                                isLoading: !disableLoading
                            });
                            _ctx.next = 6;
                            return (0,lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_1__/* .getShareTradeTarget */ .JG)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                limit: 20
                            }, restParams));
                        case 6:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            set(function(currstate) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(currstate, function(state) {
                                    if (params === null || params === void 0 ? void 0 : params.cursor) {
                                        state.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                                            targets: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(state.data.targets).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data.targets))
                                        });
                                    } else state.data = data;
                                    if (data.targets.length === 0 && !(params === null || params === void 0 ? void 0 : params.keyword) && initialLoad) {
                                        state.isEmptyList = true;
                                    }
                                    state.isLoading = false;
                                    state.error = undefined;
                                });
                            });
                            return _ctx.abrupt("return", data);
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](2);
                            set({
                                isLoading: false,
                                error: _ctx.t0
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        12
                    ]
                ]);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        loadUpdateTarget: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
                var withLoading, _args = arguments;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            withLoading = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                            _ctx.prev = 1;
                            if (withLoading) set({
                                isUpdateLoading: true
                            });
                            _ctx.next = 5;
                            return (0,lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_1__/* .putShareTradeTarget */ .wm)(requestBody);
                        case 5:
                            set({
                                isUpdateLoading: false,
                                updateError: undefined
                            });
                            return _ctx.abrupt("return", null);
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](1);
                            (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                alertType: "plain-default",
                                messageType: "error",
                                content: "Unable to save auto-share"
                            });
                            set({
                                isUpdateLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        9
                    ]
                ]);
            }));
            return function(requestBody) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetShareTradeTarget: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useShareTradeTarget);


/***/ }),

/***/ 32070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ TargetType; }
/* harmony export */ });
/* unused harmony export PaginationNextType */
var PaginationNextType;
(function(PaginationNextType) {
    PaginationNextType["Personal"] = "PERSONAL";
    PaginationNextType["Group"] = "Group";
})(PaginationNextType || (PaginationNextType = {}));
var TargetType;
(function(TargetType) {
    TargetType["Unspecified"] = "TARGET_TYPE_UNSPECIFIED";
    TargetType["ChatRoom"] = "TARGET_TYPE_CHATROOM";
    TargetType["User"] = "TARGET_TYPE_USER";
})(TargetType || (TargetType = {}));


/***/ })

}]);